"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// Redux middleware to allow side effects to be executed after reducers handle actions
// To use: In a reducer, just set a function to the `sideEffect` property of the 'action'
//
//  switch(action.actionType) {
//    case 'MY_ACTION':
//      action.addSideEffect((store) => store.dispatch(someFunction()));
//      return determineNewState(state);
//    default:
//      return state;
//  }
//
var _default = function _default(store) {
  var sideEffects = [];
  return function (next) {
    return function (action) {
      /* eslint no-param-reassign: 0 */
      // Create a 'addSideEffect' method that accumulates each side effect into the 'sideEffects' array
      action.addSideEffect = function (effect) {
        return sideEffects.push(effect);
      };
      /* eslint callback-return: 0 */
      // Pass the 'action' to 'next' before running the side effects
      // This ensures all work on the 'action' across reducers is done before side effects occur


      var result = next(action); // Run each side effect passing in the 'store' to its function

      while (sideEffects.length > 0) {
        sideEffects.shift()(store);
      }

      return result;
    };
  };
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/reduxMiddleware/actionSideEffectMiddleware.js
// module id = 4407
// module chunks = 25